import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Badge } from '@/components/ui/Badge';
import { useActiveLease } from '@/hooks/useLeases';
import { useActs } from '@/hooks/useActs';
import { formatDate } from '@/utils/format';

export function ActsPage() {
  const { t } = useTranslation();
  const { activeLease } = useActiveLease();
  const acts = useActs(activeLease?.id ?? null);

  if (acts.isLoading) return <Spinner />;

  return (
    <Card title={t('acts.title')}>
      {acts.data && acts.data.length > 0 ? (
        <table className="w-full text-left text-sm">
          <thead className="text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">{t('acts.type')}</th>
              <th>{t('common.date')}</th>
              <th>{t('acts.tenant_status')}</th>
              <th>{t('acts.owner_status')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {acts.data.map((a) => (
              <tr key={a.id} className="border-t border-slate-100">
                <td className="py-2">{t(`acts.types.${a.type}`)}</td>
                <td>{formatDate(a.created_at)}</td>
                <td>
                  <Badge tone={a.tenant_status === 'signed' ? 'success' : 'info'}>
                    {t(`acts.status.${a.tenant_status}`)}
                  </Badge>
                </td>
                <td>
                  <Badge tone={a.owner_status === 'signed' ? 'success' : 'info'}>
                    {t(`acts.status.${a.owner_status}`)}
                  </Badge>
                </td>
                <td>
                  <Link to={`/acts/${a.id}`} className="text-brand hover:underline">
                    {t('common.view')}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
